var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 362,
    viewBox: "0 0 362 362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-713 -1872)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 181,
    cy: 181,
    r: 181,
    transform: "translate(713 1872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shopify",
    transform: "translate(794.015 1938.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M175.117,45.039a2.2,2.2,0,0,0-1.985-1.844c-.826-.069-18.3-1.364-18.3-1.364S142.7,29.784,141.368,28.451s-3.935-.927-4.946-.63c-.149.044-2.651.816-6.791,2.1-4.053-11.664-11.207-22.383-23.793-22.383-.347,0-.705.014-1.063.034C101.2,2.835,96.763.779,92.933.779c-29.317,0-43.324,36.65-47.715,55.274-11.392,3.53-19.485,6.04-20.519,6.364-6.359,1.995-6.56,2.195-7.395,8.187C16.676,75.14.038,203.81.038,203.81L129.685,228.1l70.247-15.2S175.273,46.182,175.118,45.039ZM122.466,32.134l-10.97,3.4c0-.773.008-1.534.008-2.366a53.81,53.81,0,0,0-2.621-17.713C115.367,16.264,119.686,23.643,122.466,32.134ZM100.838,16.888c1.8,4.518,2.975,11,2.975,19.749,0,.448,0,.857-.008,1.271L81.149,44.924c4.363-16.837,12.54-24.969,19.689-28.036Zm-8.71-8.245a6.621,6.621,0,0,1,3.76,1.269c-9.4,4.421-19.467,15.557-23.72,37.794L54.259,53.252C59.241,36.291,71.069,8.643,92.127,8.643Z",
    transform: "translate(0 0)",
    fill: "#95bf46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M209.164,50.646c-.826-.069-18.3-1.364-18.3-1.364S178.732,37.235,177.4,35.9a3.326,3.326,0,0,0-1.873-.86l-9.8,200.509,70.241-15.2S211.3,53.633,211.15,52.491a2.2,2.2,0,0,0-1.985-1.844",
    transform: "translate(-36.033 -7.451)",
    fill: "#5e8e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M114.36,103.642,105.7,129.407a39.845,39.845,0,0,0-16.892-4.05c-13.638,0-14.324,8.558-14.324,10.715,0,11.768,30.675,16.277,30.675,43.84,0,21.686-13.754,35.65-32.3,35.65-22.255,0-33.636-13.851-33.636-13.851l5.959-19.688s11.7,10.044,21.57,10.044a8.7,8.7,0,0,0,9.074-8.789c0-15.35-25.166-16.035-25.166-41.258,0-21.229,15.237-41.773,46-41.773,11.851,0,17.706,3.395,17.706,3.395",
    transform: "translate(-8.521 -21.632)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group4.80606c5db7142da2e69194ef0f7f48a7.svg";
export { ForwardRef as ReactComponent };